import { useState } from "react";

import {
  ContainerConfigurateCommon,
  ContainerGridColumnsTableCommon,
  ContainerScrollCommon,
  TableHeaderCommonResponsive,
} from "../../common/components/TableResponsive";

import { SyncronizeVolanteNum } from "./SyncronizeVolanteNum/SyncronizeVolanteNum";
import { Authorization, useAuthorization } from "../../common/AuthorizationCpt";
import { SyncronizeManifestNum } from "./SyncronizeManifestNum/SyncronizeManifestNum";
import { SyncronizeHouseAirWaybill } from "./SyncronizeHouseAirWaybill/SyncronizeHouseAirWaybill";
import { SyncronizeUsersByName } from "./SyncronizeUsersByName/SyncronizeUsersByName";
import { SyncronizeUsersByDocumentNumber } from "./SyncronizeUsersByDocumentNumber/SyncronizeUsersByDocumentNumber";
import { SyncronizeAgentsByRuc } from "./SyncronizeAgentsByRuc/SyncronizeAgentsByRuc";

const SYNC_OPTIONS = {
  payment: {
    screenName: "Pagos",
    path: "/web/importaciones/facturacion/pagos",
    authorization: [
      "volante.synchronize_volantes_by_volante_number",
      "volante.synchronize_volantes_by_manifest_number",
      "volante.synchronize_volantes_by_house_air_waybill",
      "user.synchronize_users_by_name",
      "user.synchronize_users_by_document_number",
      "billable-ruc.synchronize_agency_by_ruc",
    ],
    children: {
      volante: {
        authorization: ["volante.synchronize_volantes_by_volante_number"],
        component: function Quoted() {
          return <SyncronizeVolanteNum />;
        },
      },
      manifest: {
        authorization: ["volante.synchronize_volantes_by_manifest_number"],
        component: function Pending() {
          return <SyncronizeManifestNum />;
        },
      },
      house: {
        authorization: ["volante.synchronize_volantes_by_house_air_waybill"],
        component: function Paid() {
          return <SyncronizeHouseAirWaybill />;
        },
      },
      userByName: {
        authorization: ["user.synchronize_users_by_name"],
        component: function Paid() {
          return <SyncronizeUsersByName />;
        },
      },
      userDocumentNumber: {
        authorization: ["user.synchronize_users_by_document_number"],
        component: function Paid() {
          return <SyncronizeUsersByDocumentNumber />;
        },
      },
      agentByRuc: {
        authorization: ["billable-ruc.synchronize_agency_by_ruc"],
        component: function Paid() {
          return <SyncronizeAgentsByRuc />;
        },
      },
    },
  },
};

export const SyncronizeData = () => {
  const authorization = useAuthorization();

  const [options] = useState(() => {
    const options = Object.keys(SYNC_OPTIONS.payment.children)
      .map((key) => SYNC_OPTIONS.payment.children[key])
      .filter((option) => {
        return authorization.isAllowedByActions(option.authorization);
      });
    return options;
  });

  const gridTemplateColumnsSyncronize = "1.5fr 2fr 1fr";

  return (
    <div style={{ marginTop: "2rem" }}>
      <div style={{ padding: "0rem 2rem" }}>
        <Authorization
          actions={[
            "volante.synchronize_volantes_by_volante_number",
            "volante.synchronize_volantes_by_manifest_number",
            "volante.synchronize_volantes_by_house_air_waybill",
            "user.synchronize_users_by_name",
            "user.synchronize_users_by_document_number",
            "billable-ruc.synchronize_agency_by_ruc",
          ]}
        >
          <ContainerScrollCommon>
            <ContainerConfigurateCommon>
              <ContainerGridColumnsTableCommon
                gridTemplateColumns={gridTemplateColumnsSyncronize}
              >
                <TableHeaderCommonResponsive className="item-container">
                  <div
                    className="main-info-header"
                    style={{ marginLeft: "2rem" }}
                  >
                    {"Sincronizar"}
                  </div>
                  <div>{"PARÁMETROS DE SINCRONIZACIÓN"}</div>
                  <div style={{ marginRight: "5rem" }}>{"ACCIONES"}</div>
                </TableHeaderCommonResponsive>
                <div
                  style={{ overflowY: "scroll", maxHeight: "90vh" }}
                  className="scroll"
                >
                  {options.map((option, i) => {
                    return (
                      <Authorization actions={option.authorization} key={i}>
                        {option.component()}
                      </Authorization>
                    );
                  })}
                </div>
              </ContainerGridColumnsTableCommon>
            </ContainerConfigurateCommon>
          </ContainerScrollCommon>
        </Authorization>
      </div>
    </div>
  );
};
